import Press from './press';
export default Press;
